import { axiosInstance } from "@/lib/axiosInstance";

export interface CollegeProfileType {
  id: string;
  college_id: string;
  name: string;
  address: string | null;
  email: string | null;
  phone: string | null;
  logo_url: string | null;
  mou_signed: boolean;
  status: string;
  accreditation: string | null;
  established_year: number | null;
  total_students: number;
  website?: string | null;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export interface CollegeProfileUpdateType {
  accreditation: string;
  established_year: number;
  total_students: number;
  website: string;
  description: string;
  name?: string;
  address?: string;
  email?: string;
  phone?: string;
}

class CollegeService {
  async fetchCollegeProfile(): Promise<CollegeProfileType> {
    const { data } = await axiosInstance.get("/v1/profile");
    return data;
  }

  async updateCollegeProfile(
    payload: CollegeProfileUpdateType
  ): Promise<CollegeProfileType> {
    const { data } = await axiosInstance.put("/v1/profile", payload);
    return data;
  }
}

export const collegeService = new CollegeService();
